export type IrrigationAdviceStatus = 'DONE' | 'RUNNING' | 'MISSING_DATA' | 'INSUFFICIENT_DATA';

export const IrrigationAdviceStatus = {
  DONE: 'DONE' as IrrigationAdviceStatus,
  RUNNING: 'RUNNING' as IrrigationAdviceStatus,
  MISSING_DATA: 'MISSING_DATA' as IrrigationAdviceStatus,
  INSUFFICIENT_DATA: 'INSUFFICIENT_DATA' as IrrigationAdviceStatus,
};
